import {Item} from "@/api/item";

export class ItemCRM extends Item {
  url = 'https://api.rekroo.org/crm/'
  timeout = 120000
}
